<template>
    <div id="categories">
        <h2>Categories</h2>
        <div class="category-group" v-for="category in categoryGroups" v-bind:key="category.idCategory">
            <div class="category-title">{{category.title}}</div>
            <div v-show="category.description" class="category-description text-muted">{{category.description}}</div>
            <div v-show="category.note" class="category-note">{{category.note}}</div>
            <div class="detail-group" v-for="detail in category.details" v-bind:key="detail.idCategoryDetail">
                <div class="detail-title">{{detail.detailTitle}}</div>
                <ul>
                    <li class="option-group" v-for="option in detail.options" v-bind:key="option.idCategoryDetailOption">
                        <span class="option-title">{{option.optionTitle}}</span>
                        <span class="option-description text-muted">{{option.optionDescription}}</span>
                    </li>
                </ul>

            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'

    export default {
        name: "Categories",
        props: ['categories', 'categoryDetails'],
        computed: {
            categoryGroups (){
                let cg = [];

                this.categories.forEach(cat => {
                    let details = _.filter(this.categoryDetails, obj => {
                        return obj.idCategory === cat.idCategory
                    });

                    let catDets = [];
                    let detailGroups = _.groupBy(details, 'idCategoryDetail');

                    Object.keys(detailGroups).forEach(idCategoryDetail => {
                        let thisDet = {
                            idCategoryDetail: idCategoryDetail,
                            detailTitle: detailGroups[idCategoryDetail][0].detailTitle,
                            detailDescription: detailGroups[idCategoryDetail][0].detailDescription,
                            options: detailGroups[idCategoryDetail]
                        };

                        catDets.push(thisDet)
                    });

                    cat.details = catDets;

                    cg.push(cat);
                });

                return cg;
            }
        }
    }
</script>

<style scoped>
    .category-group {
        font-size: 1.2em;
    }
    .category-description {
        font-size: .8em;
        margin-top: -5px;
    }
    .detail-group {
        font-size: 1rem;
    }

    .detail-title {
        font-weight: bold;
    }
    .option-title {
        display: block;
    }
    .option-description {
        display: block;
        font-size: .8em;
        margin-top: -5px;
    }
    .category-note {
        font-size: .8em;
        margin-left: 10px;
    }
</style>